import { render, staticRenderFns } from "./TermsConditionsPage.vue?vue&type=template&id=77909f6f&scoped=true"
var script = {}
import style0 from "./TermsConditionsPage.vue?vue&type=style&index=0&id=77909f6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77909f6f",
  null
  
)

export default component.exports